import { StateRule, UrlService } from '@uirouter/angular';
import { parseQueryString } from 'rev-shared/util/UrlUtil';

/**
 * Resolves the ui-router state for a URL.
 */
export function resolveState(url: string, $url: UrlService): string {
	const parts = parseStateUrl(url);
	const match = $url.match(parts);
	return (match?.rule as StateRule).state?.name || '';
}

function parseStateUrl(url: string): { path: string; search: any; hash: string } {
	const match = url.match(/([^?#]*)(\?[^#]*)?(#.*)?/);
	return {
		path: match?.[1] || '',
		search: parseQueryString(match?.[2] || ''),
		hash: match?.[3] || ''
	};
}
